import React, { useState } from "react";
import cn from "clsx";
import { DialogOverlay, DialogContent } from "@reach/dialog";

import CloseIcon from "../../Icons/Close";

import CoinsCalculator from "./CoinsCalculator";
import CoinsPricingList from "../CoinInfoModal/CoinsPricingList";
import UserCoinsContainer from "../CoinInfoModal/UserCoinsContainer";
import AuthenticationModal, { SIGN_UP } from "../AuthenticationModal";

import useModalToggleTracking from "../../../hooks/useModalToggleTracking";
import usePageDefaults from "../../../hooks/usePageDefaults";

const CoinCalculatorModal = (props) => {
  const [isAuthModalOpen, setIsAuthModalOpen] = useState(false);
  const {
    pageDefaults: {
      freeSendCap,
      freeSendCapPerRecipientCoinPrice,
    },
    coinPackages,
  } = usePageDefaults();
  const { productType, isOpen, coinsPerRecipient, isFreeInvite, isInvite, onDismiss } = props;

  useModalToggleTracking(isOpen, { id: "coinCalculator" });

  return isAuthModalOpen === false ? (
    <DialogOverlay
      className="fixed inset-0 overflow-auto bg-lapel bg-opacity-20 z-30"
      isOpen={isOpen}
      onDismiss={onDismiss}
    >
      <DialogContent
        className="flex flex-col w-full mx-auto bg-white text-lapel md:mt-16 md:mb-4 px-6 pt-10 fixed inset-0 md:relative overflow-y-auto md:w-[30rem] lg:h-auto"
        aria-label="Card Preview Modal"
      >
        <div
          className="flex justify-end fixed md:absolute w-full px-4 pt-4 top-0 left-0 right-0 cursor-pointer"
          onClick={onDismiss}
        >
          <CloseIcon className="" width="1.5rem" height="1.5rem" />
        </div>
        <CoinsCalculator
          coinsPerRecipient={coinsPerRecipient}
          isFreeInvite={isFreeInvite}
          isInvite={isInvite}
          coinPackages={coinPackages}
          freeSendCap={freeSendCap}
          freeSendCapPerRecipientCoinPrice={freeSendCapPerRecipientCoinPrice}
          preferredCurrency="USD"
          openSignUpModal={setIsAuthModalOpen}
        />
        <div
          className={cn("paragraph-small", {
            "pt-14 paragraph-medium": productType === "flyer",
          })}
        >
          <CoinsPricingList
            coinPackages={coinPackages}
            preferredCurrency="USD"
            productType={productType}
          />
          <UserCoinsContainer openSignUpModal={setIsAuthModalOpen} />
        </div>
      </DialogContent>
    </DialogOverlay>
  ) : (
    <AuthenticationModal
      initialContent={SIGN_UP}
      isOpen={isAuthModalOpen}
      onDismiss={() => {
        setIsAuthModalOpen(false);
        onDismiss();
      }}
    />
  );
};

export default CoinCalculatorModal;
